const notificationsData = [{
  date: '01/21/2012',
  notificationsByType: [{
    time: '10:07 PM on 12/31/2021',
    type: 'credentials-outdated',
    id: 1,
    notifications: [[{
      title: '8558 Green Rd.',
      link: '/active_dashboard'
    }, {
      title: 'San Francisco Public Utilities Commission'
    }, {
      title: 'Water, Sewer, Trash'
    }]]
  }, {
    time: '00:00 PM on 12/31/2021',
    type: 'bill-spike-alert',
    id: 2,
    notifications: [[{
      title: '8558 Green Rd.',
      link: '/active_dashboard'
    }, {
      title: 'Water bill spike (+32%)'
    }]]
  }]
}, {
  date: '03/12/2021',
  notificationsByType: [{
    time: '14:56 PM on 12/31/2021',
    type: 'new-billing-cycle',
    id: 3,
    notifications: [[{
      title: '8558 Green Rd.',
      link: '/active_dashboard'
    }, {
      title: 'November billing cycle'
    }]]
  }]
}, {
  date: '07/10/2012',
  notificationsByType: [{
    time: '08:10 PM on 12/31/2021',
    type: 'balance-overdue',
    id: 4,
    notifications: [[{
      title: 'All properties'
    }, {
      title: '34 residents have overdue balance'
    }]]
  }, {
    time: '12:13 PM on 12/31/2021',
    id: 5,
    type: 'monthly-reports-ready',
    notifications: [[{
      title: '8558 Green Rd.',
      link: '/active_dashboard'
    }, {
      title: 'November billing cycle'
    }]]
  }]
}];
export default notificationsData;